import { gql } from 'urql';

export const ModRewardTemplateDetails = gql`
  fragment ModRewardTemplateDetails on ModRewardTemplate {
    id
    name
    description
    modRunnerNote
    finalizedAt
    modRewards {
      id
      stack
      item {
        id
        name
        kind
      }
      modRewardClaims {
        id
        stack
        modSignup {
          id
          character {
            id
            name
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
